
exports.Steps = (handler) ->
    self = this

    @getClass = (data) ->
        if data.id is self.current()
            if data.id is self.final_step.id
                return "btn btn-blue spp-final"
            else
                return "btn spp-button btn-primary"
        else if data.visited() and not data.skipped()
            if data.id is self.final_step.id
                return "btn btn-light-blue spp-final"
            else
                return "btn spp-button btn-light-green"
        else
            if data.id is self.final_step.id
                return "btn spp-final"
            else
                return "btn spp-button "


    @getText = (data) ->
        if data.id is self.final_step.id
            return "Fit Seed to Field"
        else
            return data.step_order


    @getEnabled = (data) ->
        return data.visited() or data.skipped()


    @setCurrent = (id) ->
        @current id
        for v in @steps
            if v.id is id
                v.visited true
                break


    @goToStep = (step) ->
        if step.id isnt self.current()
            handler.goToStep(step.step_order, true)


    @steps = handler.taffyObjects.steps().get()

    for step in @steps
        step.visited = ko.observable(step.visited)
        step.skipped = ko.observable(step.skipped)
    @steps[0].visited true

    @current = ko.observable handler.curStep?.num
    @final_step = @steps[(@steps.length - 1)]

    return this
